"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useState } from "react";
export default function OurStory() {
  const {
    ref: rightPanelRef,
    isVisible: rightPanelVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: timelineRef,
    isVisible: timelineVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const timelineEvents = [{
    year: "2010",
    title: "Founded",
    description: "Mike started A+ Fire with a commitment to direct, honest service."
  }, {
    year: "2015",
    title: "Expansion",
    description: "Grew to serve all of Northern Virginia with comprehensive fire protection."
  }, {
    year: "2020",
    title: "Certified Excellence",
    description: "Achieved full certification and insurance, maintaining family-owned values."
  }, {
    year: "2025",
    title: "Today",
    description: "Continuing to provide hands-on, owner-direct service across the region."
  }];
  return <section className="relative min-h-screen bg-light-background">
      {}
      <div className="absolute left-1/2 top-0 bottom-0 w-[2px] bg-primary/30 animate-pulse hidden lg:block" style={{
      animationDuration: "2s"
    }} />
      
      <div className="flex flex-col lg:flex-row min-h-screen">
        {}
        <div className="lg:w-1/2 h-[50vh] lg:h-screen lg:sticky lg:top-0 relative overflow-hidden">
          <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1470228/img/image_3u4mtgw5.jpg)] bg-cover bg-center" />
          <div className="absolute inset-0 bg-gradient-to-t from-dark-background/60 via-transparent to-transparent" />
        </div>

        {}
        <div ref={rightPanelRef} className={`lg:w-1/2 flex flex-col justify-center px-6 sm:px-12 lg:px-16 py-16 lg:py-24 transition-all duration-[var(--duration-slow)] ${rightPanelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="mb-8">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground-light leading-tight mb-4">
              Family-Owned.<br />
              <span className="text-primary">Fire-Focused.</span>
            </h2>
            <div className="h-1 w-24 bg-primary rounded-full" />
          </div>

          {}
          <div className="mb-12 space-y-4">
            <p className="text-lg text-foreground-light/80 leading-relaxed">
              A+ Fire was built on a simple principle: when you call for fire protection, you should speak directly with the person doing the work—not a secretary, not a call center, but Mike himself.
            </p>
            <p className="text-lg text-foreground-light/80 leading-relaxed">
              Since day one, we've provided honest, hands-on fire safety services across Northern Virginia. From fire extinguisher inspections to Ansul hood systems, we handle every job with the care and expertise you'd expect from a family-owned business.
            </p>
            <p className="text-lg text-foreground-light/80 leading-relaxed">
              Our commitment is simple: fast response, certified work, and no upselling. Just reliable fire protection when you need it most.
            </p>
          </div>

          {}
          <div ref={timelineRef} className={`relative transition-all duration-[var(--duration-slow)] ${timelineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <h3 className="font-display text-2xl font-bold text-foreground-light mb-8">
              Our Journey
            </h3>
            
            <div className="space-y-6">
              {timelineEvents.map((event, i) => <div key={i} data-index={i} className="relative pl-12 pb-6 last:pb-0" onMouseEnter={() => setHoveredIndex(i)} onMouseLeave={() => setHoveredIndex(null)}>
                  {}
                  <div className={`absolute left-0 top-1 w-6 h-6 rounded-full border-2 border-primary bg-light-background transition-all duration-[var(--duration-medium)] ${hoveredIndex === i ? "scale-125 bg-primary" : ""}`} />
                  
                  {}
                  {i < timelineEvents.length - 1 && <div className={`absolute left-3 top-7 w-0.5 h-full bg-primary/30 transition-all duration-[var(--duration-medium)] origin-top ${hoveredIndex === i ? "scale-y-110 bg-primary/60" : ""}`} />}
                  
                  {}
                  <div className={`transition-all duration-[var(--duration-medium)] ${hoveredIndex === i ? "translate-x-1" : ""}`}>
                    <div className="font-display text-sm font-bold text-primary mb-1">
                      {event.year}
                    </div>
                    <h4 className="text-xl font-semibold text-foreground-light mb-2">
                      {event.title}
                    </h4>
                    <p className="text-foreground-light/70 leading-relaxed">
                      {event.description}
                    </p>
                  </div>
                </div>)}
            </div>

            {}
            <div className="mt-12 rounded-lg overflow-hidden shadow-medium">
              <div className="bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1470228/img/timeline_graphic_illustration.png)] bg-cover bg-center h-64 w-full" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}